<div class="spinner-grid-size">
  <ngx-loading
    [show]="!loaded"
    [config]="{
      backdropBorderRadius: '3px',
      animationType: ngxLoadingAnimationTypes.circle,
      primaryColour: this.primaryColour,
      secondaryColour: this.secondaryColour
    }">
  </ngx-loading>
</div>
<img
  style="max-width: 100%; max-height: 100%"
  [ngStyle]="{ opacity: zoom ? 0 : loaded ? 1 : 0 }"
  class="{{ cssClass }}"
  [src]="imgData"
  #imgTag />
